import { ErrorLayout as Layout } from '../../../layouts/Error/ErrorLayout';
import { DevSetup } from './DevSetup/DevSetup';

export const DevSetupPage = () => {
  return (
    <Layout>
      <DevSetup />
    </Layout>
  );
};
